import { setReplaceSvg } from './_common'
//import pagesIndex from './pages/home/_index'
import setTemplates from './templates/front/_index'
import pagePreRegistration from './pages/pre_registration';
import pageProfileIndex from './pages/profile/index';
import pageMagazineIndex from './pages/magazine/index';
import pageMagazineShow from './pages/magazine/show';

window.addEventListener('load', () => {
    setReplaceSvg()
    setTemplates();
    pagePreRegistration();
    pageProfileIndex();
    pageMagazineIndex();
    pageMagazineShow();
})
